<template>
  <div>
    <div class="message-page-container">
      <h1>消息</h1>
      <ul class="message-container">
        <!--   vip秘书     -->
        <li
          v-if="isNotExistVipService"
          @click="$router.push({ name: 'chat', params: { id: vipId } })"
        >
          <div class="avatar">
            <img src="../../assets/message/vip@2x.png" alt="" />
          </div>
          <div class="info">
            <h2>VIP充值小秘书</h2>
          </div>
        </li>
        <!--   在线客服     -->
        <li
          v-if="isNotExistService"
          @click="$router.push({ name: 'chat', params: { id: serviceId } })"
        >
          <div class="avatar">
            <img src="../../assets/message/services@2x.png" alt="" />
          </div>
          <div class="info">
            <h2>在线咨询客服</h2>
          </div>
        </li>
        <!--   普通用户     -->
        <li
          v-for="conversation in conversationList"
          :key="conversation.key"
          @click="navigateTo(conversation.name)"
        >
          <div class="avatar">
            <img
              v-if="conversation.name === vipId"
              src="../../assets/message/vip@2x.png"
              alt=""
            />
            <img
              v-else-if="conversation.name === serviceId"
              src="../../assets/message/services@2x.png"
              alt=""
            />
            <img
              v-else
              :src="conversation.avatar ? conversation.avatar : defaultAvatar"
              alt=""
            />
            <span v-if="conversation.unread_msg_count > 0" class="dot">{{
              conversation.unread_msg_count
            }}</span>
          </div>
          <div class="info">
            <h2>{{ conversation.nickName }}</h2>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import defaultAvatar from "@/assets/personal/default_avatar@2x.png";

import { mapState } from "vuex";

export default {
  name: "Message",
  computed: {
    ...mapState("chat", ["conversationList"]),
    ...mapState("platform", ["vipId", "serviceId"]),
    isNotExistVipService() {
      return !this.conversationList.some(({ name }) => name === this.vipId);
    },
    isNotExistService() {
      return !this.conversationList.some(({ name }) => name === this.serviceId);
    }
  },
  data() {
    return {
      defaultAvatar
    };
  },
  methods: {
    async fetchData() {
      const result = await this.getConversation();
      console.log(result);
    },
    navigateTo(id) {
      this.$router.push({ name: "chat", params: { id } });
    }
  }
};
</script>

<style lang="scss" scoped>
.message-page-container {
  padding: 15px 15px 70px 15px;
  h1 {
    margin-bottom: 15px;
    font-size: 26px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 37px;
    text-align: left;
  }
  .message-container {
    display: flex;
    flex-direction: column;
    text-align: left;
    li {
      padding: 9px 0;
      display: flex;
      align-items: center;
      .avatar {
        position: relative;
        margin-right: 10px;
        img {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          overflow: hidden;
        }
        .dot {
          position: absolute;
          left: 35px;
          top: 0;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: rgba(255, 32, 69, 1);
          font-size: 9px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 14px;
          text-align: center;
        }
      }
      .info {
        display: flex;
        flex-direction: column;
        h2 {
          font-size: 15px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 21px;
        }
        p {
          font-size: 11px;
          font-weight: 500;
          color: rgba(153, 153, 153, 1);
          line-height: 16px;
        }
      }
    }
  }
}
</style>
